/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'
export class ReportsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Parking Sessions By Make Model
   * @returns any Successful Response
   * @throws ApiError
   */
  public parkingSessionsByMakeModel({
    regionId,
    shapeLayerUuid,
    startDate,
    endDate,
    operator,
    accept = 'text/csv',
  }: {
    /**
     * Region identifier
     */
    regionId: string
    /**
     * Layer identifier
     */
    shapeLayerUuid: string
    /**
     * Filter for parking sessions that started after the provided ISO start date (inclusive)
     */
    startDate: string
    /**
     * Filter for parking sessions that started on or before the provided ISO end date (inclusive)
     */
    endDate: string
    /**
     * The operator for which to compile parking sessions
     */
    operator: string
    accept?: string
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/regions/{region_id}/mobility/reports/layers/{shape_layer_uuid}/parking_sessions_by_make_model',
      path: {
        region_id: regionId,
        shape_layer_uuid: shapeLayerUuid,
      },
      headers: {
        accept: accept,
      },
      query: {
        start_date: startDate,
        end_date: endDate,
        operator: operator,
      },
      errors: {
        422: `Validation Error`,
      },
    })
  }
}
